<!-- SkyPlus Warehouse Dashboard -->
<div class="sp-dashboard-container">
  <!-- HEADER - Same as Dashboard -->
  <sp-header></sp-header>

  <!-- MAIN CONTENT -->
  <main class="sp-main">
    <!-- Page Header -->
    <div class="sp-page-header">
      <div class="sp-greeting">
        <h1><span class="material-icons page-icon">warehouse</span> Warehouse Dashboard</h1>
        <p>Inventory management and stock control</p>
      </div>
      <div class="sp-header-actions">
        <div class="filter-group">
          <select [(ngModel)]="selectedWarehouse" (change)="onWarehouseChange(selectedWarehouse)">
            <option *ngFor="let wh of warehouses" [value]="wh.value">{{ wh.label }}</option>
          </select>
          <select [(ngModel)]="selectedTimeRange" (change)="onTimeRangeChange(selectedTimeRange)">
            <option *ngFor="let range of timeRanges" [value]="range.value">{{ range.label }}</option>
          </select>
        </div>
        <button class="sp-refresh-btn" (click)="refreshData()" [disabled]="isLoading">
          <span class="material-icons" [class.spinning]="isLoading">refresh</span>
        </button>
        <button class="btn btn-primary" (click)="exportReport()">
          <span class="material-icons">download</span> Export
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div class="sp-loading" *ngIf="isLoading">
      <span class="material-icons spinning">autorenew</span>
      <p>Loading warehouse data...</p>
    </div>

    <!-- Main Content (when not loading) -->
    <div class="warehouse-content" *ngIf="!isLoading">
      
      <!-- Stats Cards Row -->
      <section class="sp-stats-section">
        <div class="sp-stat-card">
          <div class="sp-stat-icon blue"><span class="material-icons">inventory_2</span></div>
          <div class="sp-stat-content">
            <div class="sp-stat-value">{{ formatNumber(stats.totalItems) }}</div>
            <div class="sp-stat-label">Total Items</div>
          </div>
        </div>

        <div class="sp-stat-card">
          <div class="sp-stat-icon green"><span class="material-icons">payments</span></div>
          <div class="sp-stat-content">
            <div class="sp-stat-value">{{ formatCurrency(stats.totalValue) }}</div>
            <div class="sp-stat-label">Inventory Value</div>
          </div>
        </div>

        <div class="sp-stat-card">
          <div class="sp-stat-icon orange"><span class="material-icons">warning</span></div>
          <div class="sp-stat-content">
            <div class="sp-stat-value">{{ stats.lowStockItems }}</div>
            <div class="sp-stat-label">Low Stock Items</div>
          </div>
        </div>

        <div class="sp-stat-card">
          <div class="sp-stat-icon purple"><span class="material-icons">pending_actions</span></div>
          <div class="sp-stat-content">
            <div class="sp-stat-value">{{ stats.pendingOrders }}</div>
            <div class="sp-stat-label">Pending Orders</div>
          </div>
        </div>

        <div class="sp-stat-card">
          <div class="sp-stat-icon teal"><span class="material-icons">local_shipping</span></div>
          <div class="sp-stat-content">
            <div class="sp-stat-value">{{ stats.itemsShippedToday }}</div>
            <div class="sp-stat-label">Shipped Today</div>
          </div>
        </div>

        <div class="sp-stat-card">
          <div class="sp-stat-icon indigo"><span class="material-icons">move_to_inbox</span></div>
          <div class="sp-stat-content">
            <div class="sp-stat-value">{{ stats.itemsReceivedToday }}</div>
            <div class="sp-stat-label">Received Today</div>
          </div>
        </div>
      </section>

      <!-- Main Grid -->
      <div class="dashboard-grid">
        
        <!-- Left Column -->
        <div class="grid-left">
          
          <!-- Inventory by Category -->
          <section class="card categories-card">
            <div class="card-header">
              <span class="material-icons">category</span>
              <h2>Inventory by Category</h2>
            </div>
            <div class="card-content">
              <div class="category-list">
                <div class="category-item" *ngFor="let category of categories">
                  <div class="category-info">
                    <span class="category-name">{{ category.name }}</span>
                    <span class="category-count">{{ formatNumber(category.count) }} items</span>
                  </div>
                  <div class="category-stats">
                    <span class="category-value">{{ formatCurrency(category.value) }}</span>
                    <span class="category-trend" [ngClass]="getTrendClass(category.trend)">
                      <span class="material-icons">{{ getTrendIcon(category.trend) }}</span>
                    </span>
                  </div>
                  <div class="category-bar">
                    <div class="category-progress" [style.width.%]="category.percentage"></div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- Warehouse Locations -->
          <section class="card locations-card">
            <div class="card-header">
              <span class="material-icons">location_on</span>
              <h2>Warehouse Locations</h2>
            </div>
            <div class="card-content">
              <div class="locations-grid">
                <div class="location-card" *ngFor="let location of warehouseLocations">
                  <div class="location-header">
                    <span class="location-name">{{ location.name }}</span>
                    <span class="location-items">{{ formatNumber(location.items) }} items</span>
                  </div>
                  <div class="location-capacity">
                    <div class="capacity-bar" [ngClass]="getCapacityClass(location)">
                      <div class="capacity-fill" [style.width.%]="getCapacityPercentage(location)"></div>
                    </div>
                    <div class="capacity-info">
                      <span>{{ formatNumber(location.used) }} / {{ formatNumber(location.capacity) }} units</span>
                      <span class="capacity-percent" [ngClass]="getCapacityClass(location)">
                        {{ getCapacityPercentage(location) }}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <!-- Right Column -->
        <div class="grid-right">
          
          <!-- Recent Activity -->
          <section class="card activity-card">
            <div class="card-header">
              <span class="material-icons">history</span>
              <h2>Recent Activity</h2>
              <button class="link-btn" (click)="viewAllActivities()">View All</button>
            </div>
            <div class="card-content">
              <div class="activity-list">
                <div class="activity-item" *ngFor="let activity of recentActivities">
                  <div class="activity-icon" [ngClass]="getActivityClass(activity.type)">
                    <span class="material-icons">{{ getActivityIcon(activity.type) }}</span>
                  </div>
                  <div class="activity-content">
                    <span class="activity-desc">{{ activity.description }}</span>
                    <div class="activity-meta">
                      <span class="activity-qty">
                        <span class="material-icons">inventory</span>
                        {{ activity.quantity > 0 ? '+' : '' }}{{ activity.quantity }} items
                      </span>
                      <span class="activity-user">
                        <span class="material-icons">person</span>
                        {{ activity.user }}
                      </span>
                    </div>
                  </div>
                  <div class="activity-time">
                    <span class="status-badge" [ngClass]="getStatusClass(activity.status)">
                      {{ activity.status }}
                    </span>
                    <span class="time">{{ formatTimeAgo(activity.timestamp) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- Low Stock Alerts -->
          <section class="card alerts-card">
            <div class="card-header">
              <span class="material-icons">notification_important</span>
              <h2>Low Stock Alerts</h2>
              <button class="link-btn" (click)="viewAllAlerts()">View All</button>
            </div>
            <div class="card-content">
              <div class="alerts-list">
                <div class="alert-item" *ngFor="let alert of lowStockAlerts">
                  <div class="alert-icon">
                    <span class="material-icons">warning</span>
                  </div>
                  <div class="alert-content">
                    <span class="alert-item-name">{{ alert.itemName }}</span>
                    <span class="alert-item-code">{{ alert.itemCode }}</span>
                    <div class="alert-stock">
                      <span class="current-stock">{{ alert.currentStock }}</span>
                      <span class="stock-divider">/</span>
                      <span class="reorder-level">{{ alert.reorderLevel }}</span>
                    </div>
                  </div>
                  <div class="alert-actions">
                    <button class="btn-icon" title="View Details" (click)="viewItemDetails(alert.itemCode)">
                      <span class="material-icons">visibility</span>
                    </button>
                    <button class="btn-icon primary" title="Create Reorder" (click)="createReorderRequest(alert)">
                      <span class="material-icons">add_shopping_cart</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- Quick Actions -->
          <section class="card quick-actions-card">
            <div class="card-header">
              <span class="material-icons">flash_on</span>
              <h2>Quick Actions</h2>
            </div>
            <div class="card-content">
              <div class="quick-actions-grid">
                <button class="quick-action" (click)="receiveGoods()">
                  <span class="material-icons">add_box</span>
                  <span>Receive Goods</span>
                </button>
                <button class="quick-action" (click)="shipOrder()">
                  <span class="material-icons">outbox</span>
                  <span>Ship Order</span>
                </button>
                <button class="quick-action" (click)="stockCount()">
                  <span class="material-icons">inventory</span>
                  <span>Stock Count</span>
                </button>
                <button class="quick-action" (click)="transferStock()">
                  <span class="material-icons">swap_horiz</span>
                  <span>Transfer</span>
                </button>
                <button class="quick-action" (click)="processReturns()">
                  <span class="material-icons">assignment_return</span>
                  <span>Returns</span>
                </button>
                <button class="quick-action" (click)="scanItem()">
                  <span class="material-icons">qr_code_scanner</span>
                  <span>Scan Item</span>
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </main>
</div>
